export default __webpack_public_path__ + "static/media/pata_md.ee811c53.png";